import { ThemeBlueprint } from '@backstage/plugin-app-react';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { UnifiedThemeProvider } from '@backstage/theme';
import { darkTheme, lightTheme } from '@internal/backstage-plugin-hm-common';
import { RiMoonFill, RiSunFill } from '@remixicon/react';

export const lightThemeExtension: ExtensionDefinition = ThemeBlueprint.make({
  name: 'light-default',
  params: {
    theme: {
      id: 'light-default',
      title: 'Light',
      variant: 'light',
      icon: <RiSunFill />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={lightTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const darkThemeExtension: ExtensionDefinition = ThemeBlueprint.make({
  name: 'dark-default',
  params: {
    theme: {
      id: 'dark-default',
      title: 'Dark',
      variant: 'dark',
      icon: <RiMoonFill />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={darkTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});
